function createMetas(props, defaultProps, propertiesMap) {
  const allowedKeys = Object.keys(propertiesMap);
  const mergedProps = { ...defaultProps, ...props };

  return allowedKeys
    .filter(key => !!mergedProps[key])
    .reduce(
      (acc, key) => [
        ...acc,
        {
          property: propertiesMap[key],
          content: mergedProps[key]
        }
      ],
      []
    );
}

export default createMetas;
